import { createStructuredSelector } from "reselect";
import {
    SUPPLIER_LIST,
    SUPPLIER_LIST_SUCCESS,
    SUPPLIER_LIST_ERROR,
    ADD_FORM,
    ADD_FORM_SUCCESS,
    ADD_FORM_ERROR,
    FORM_UPLOAD_SET,
    FORM_UPLOAD_SET_SUCCESS,
    FORM_UPLOAD_SET_ERROR,
    FORM_UPLOAD_RESET,
    DESTINATION_LIST,
    DESTINATION_LIST_SUCCESS,
    DESTINATION_LIST_ERROR
} from "../actions";

export const NAME = 'main';

export const SupplierList = (data) => ({
    type: SUPPLIER_LIST,
    payload: data
});

export const SupplierListSuccess = (data) => ({
    type: SUPPLIER_LIST_SUCCESS,
    payload: data
});

export const SupplierListError = (error) => ({
    type: SUPPLIER_LIST_ERROR,
    payload: error
});

export const AddForm = (data) => ({
    type: ADD_FORM,
    payload: data
});

export const AddFormSuccess = (data) => ({
    type: ADD_FORM_SUCCESS,
    payload: data
});

export const AddFormError = (error) => ({
    type: ADD_FORM_ERROR,
    payload: error
});

export const FormUploadSet = (file) => ({
    type: FORM_UPLOAD_SET,
    payload: { file },
});

export const FormUploadSetSuccess = (items) => ({
    type: FORM_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const FormUploadSetError = (error) => ({
    type: FORM_UPLOAD_SET_ERROR,
    payload: error,
});

export const FormUploadReset = () => ({
    type: FORM_UPLOAD_RESET
});

const main = (state) => state[NAME];

export const MainSelector = createStructuredSelector({
    main
})
